import { createContext } from "react"
export { ModalsContext, ModalsProvider } from "./Modals"
export { TLOContext, useTLOContext, TLOContextProvider } from "./TLO"

export { NavigationContext, NavigationProvider } from "./Navigation"

export const LocalizationContext = createContext()
LocalizationContext.displayName = "LocalizationContext"

export const RecordContext = createContext()
RecordContext.displayName = "RecordContext"
